// extracted by mini-css-extract-plugin
export default {"button":"ButtonsSelect_button__PEIGW"};